// @ts-check

/**
 * @module strings/format
 */

/**
 * Replaces placeholders within a template string with corresponding values.
 *
 * @param {string} template - Template string.
 * @param {RegExp} regex - Regular expression to detect placeholders within template.
 * @param {string[]} values - Template replacement values.
 *
 * Template string placeholder format is specified by the `regex` parameter.
 */
export function formatString(template, regex, ...values) {
    if (!template) {
        throw TypeError('Template not specified');
    }

    if (typeof template !== 'string') {
        throw TypeError('Template is not a string');
    }

    return template.replace(
        regex,
        (match, number) => number in values ? values[number] : match
    );
}

/**
 * Replaces placeholders within a template string with corresponding values.
 *
 * @param {string} template - Template string.
 * @param {string[]} values - Template replacement values.
 *
 * Template string placeholder format: {n}, where n >= 0 and n < values.length
 */
export function formatLanguageString(template, ...values) {
    const regex = /\{(\d+)\}/g;

    return formatString(template, regex, ...values);
}
